// extracted by mini-css-extract-plugin
export default {"title":"EPLI_title__DfJyA","description":"EPLI_description__WS-UZ","subTitle":"EPLI_subTitle__jn9UI"};